// src/services/geral/LeadCaptacaoService.js
import { fetchData } from '../Api';
import { LeadCaptacao } from '../../models/geral/LeadCaptacao';

export const listarLeadsCaptacao = async ({ pagina = 1, tamanhoPagina = 20, busca = '', intencao = '' } = {}) => {
  const parametros = { pagina, tamanhoPagina };
  if (busca.trim()) parametros.busca = busca.trim();
  if (intencao) parametros.intencao = intencao;
  const resultado = await fetchData('/LeadCaptacao', parametros);
  return {
    itens: resultado.itens.map(dados => new LeadCaptacao(dados)),
    total: resultado.total,
    pagina: resultado.pagina,
    tamanhoPagina: resultado.tamanhoPagina,
  };
};

export const obterLeadCaptacao = async id => new LeadCaptacao(await fetchData(`/LeadCaptacao/${id}`));
